import {
  Client,
  useClientCommunicationNoShowMutation, useClientSubscription
} from '../../shared';
import { useConfirm } from '@coverright/features';
import { theme } from '../../app/theme';
import * as React from 'react';
import {
  Dialog, DialogContent, DialogTitle,
  ThemeProvider,
  Typography
} from '@mui/material';
import { StatusForm } from '../status-form';
import { ApolloProvider } from '@apollo/client';
import { enrollmentApolloClient } from '@coverright/data-access/apollo-clients';
import { getDialogContainer } from '@coverright/utils';
import { createRoot } from 'react-dom/client';
import { ModalCloseButton } from '@coverright/ui/shared';


export const useTagMissAppConfirm = (clientId: string) => {
  const [noShow] = useClientCommunicationNoShowMutation({
    variables: {clientId: clientId}
  })
  const confirm = useConfirm(theme);
  const {client} = useClientSubscription(clientId)

  return () => confirm({
    title: 'Client didn\'t show up for the appointment',
    content: <>
      <Typography variant={'h4'}>Do you want to assign this lead to the CSR team?</Typography>
      <Typography color={'text.secondary'} variant={'body2'}>
        <i>This means that CSRs will call this client over a 7 day cadence until they reach the client</i>
      </Typography>
    </>,
    okButtonTitle: 'Yes',
    cancelButtonTitle: 'No',
  }).then(async val => {
    if (val) {
     noShow();
     return true;
    } else {
      return await renderStatusForm(client);
    }
  })
}

const renderStatusForm = (client?: Partial<Client>) => {
  return new Promise<boolean>((resolve) => {
    const container = getDialogContainer('status-form-dialog-container');
    const root = createRoot(container);

    document.body.style.setProperty('overflow', 'hidden');
    document.body.style.setProperty('padding-right', '15px');

    const close = (val: boolean) => {
      root.unmount();
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('padding-right');
      resolve(val);
    }

    root.render(
      <ThemeProvider theme={theme}>
        <ApolloProvider client={enrollmentApolloClient}>
          <Dialog fullWidth maxWidth={'xs'} open onClose={() => close(false)}>
            <DialogTitle variant={'h3'}>
              Status
              <ModalCloseButton onClick={() => close(false)}
                                sx={{position: 'absolute', top: 4, right: 8}} />
            </DialogTitle>
            <DialogContent>
              {client ? <StatusForm client={client} onSubmit={close} /> : 'Loading...'}
            </DialogContent>
          </Dialog>
        </ApolloProvider>
      </ThemeProvider>
    )
  })
}
